var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerBi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "4 2 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2001 9.8999H68.2001C70.2001 9.8999 71.8001 11.4999 71.8001 13.4999V92.9999C71.8001 94.9999 70.2001 96.5999 68.2001 96.5999H45.2001C43.2001 96.5999 41.6001 94.9999 41.6001 92.9999V13.3999C41.6001 11.4999 43.2001 9.8999 45.2001 9.8999Z",
    fill: "url(#paint0_linear_165_1391)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 92.9999V96.5999H50.4H27.4C25.4 96.5999 23.8 94.9999 23.8 92.9999V34.9999C23.8 32.9999 25.4 31.3999 27.4 31.3999H50.4C52.4 31.3999 54 32.9999 54 34.9999V92.9999Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 92.9999V96.5999H50.4H27.4C25.4 96.5999 23.8 94.9999 23.8 92.9999V34.9999C23.8 32.9999 25.4 31.3999 27.4 31.3999H50.4C52.4 31.3999 54 32.9999 54 34.9999V92.9999Z",
    fill: "url(#paint1_linear_165_1391)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 92.9997V96.5997H32.9H9.90004C7.90004 96.5997 6.30005 94.9997 6.30005 92.9997V56.7997C6.30005 54.7997 7.90004 53.1997 9.90004 53.1997H32.9C34.9 53.1997 36.5 54.7997 36.5 56.7997V92.9997Z",
    fill: "url(#paint2_linear_165_1391)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_165_1391",
    x1: 56.6797,
    y1: 9.9007,
    x2: 56.6797,
    y2: 96.5887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBBB14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B25400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_165_1391",
    x1: 38.9316,
    y1: 31.4589,
    x2: 38.9316,
    y2: 96.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_165_1391",
    x1: 21.4535,
    y1: 53.2502,
    x2: 21.4535,
    y2: 96.6257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9E68B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3CD32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerBi);
export default __webpack_public_path__ + "static/media/PowerBI.9a41f7308a7fd2cac909556a12e1b9fa.svg";
export { ForwardRef as ReactComponent };